import axios from "../axios-auth";
import orginal_axios from "axios";

export const locationMovementService = {
    getLocationMovements,
    saveLocationMovement,
    getAllLocationMovementList,
    printLocationMovementInvoice,
    exportAllLocationMovementExcel,
    getLocationMovementExcelTemplate,
    saveLocationMovementExcel
}

function saveLocationMovement(locationMovement) {
    if (!locationMovement.id) {
        return axios.post("/auth/location-movement", locationMovement);
    }
}

function getLocationMovements(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.fromWarehouseId) {
        params["fromWarehouseId"] = searchParams.fromWarehouseId;
    }
    if (searchParams.toWarehouseId) {
        params["toWarehouseId"] = searchParams.toWarehouseId;
    }
    if (searchParams.fromBinId) {
        params["fromBinId"] = searchParams.fromBinId;
    }
    if (searchParams.toBinId) {
        params["toBinId"] = searchParams.toBinId;
    }
    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }
    if (searchParams.serialNo) {
        params["serialNo"] = searchParams.serialNo;
    }
    if (searchParams.referenceNo) {
        params["referenceNo"] = searchParams.referenceNo;
    }
    if (searchParams.updateUserId) {
        params["updateUserId"] = searchParams.updateUserId;
    }
    if (searchParams.fromBinIds) {
        params["fromBinIds"] = searchParams.fromBinIds.join();
    }
    if (searchParams.toBinIds) {
        params["toBinIds"] = searchParams.toBinIds.join();
    }
    return axios.get("/auth/location-movement", { params });
}

function getAllLocationMovementList(searchParams) {
    let params = {
        sort: "fromWarehouseName,asc"
    };
    if (searchParams.fromWarehouseId) {
        params["fromWarehouseId"] = searchParams.fromWarehouseId;
    }
    if (searchParams.toWarehouseId) {
        params["toWarehouseId"] = searchParams.toWarehouseId;
    }
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }
    if (searchParams.serialNo) {
        params["serialNo"] = searchParams.serialNo;
    }
    if (searchParams.referenceNo) {
        params["referenceNo"] = searchParams.referenceNo;
    }
    if (searchParams.fromBinId) {
        params["fromBinId"] = searchParams.fromBinId;
    }
    if (searchParams.toBinId) {
        params["toBinId"] = searchParams.toBinId;
    }
    if (searchParams.updateUserId) {
        params["updateUserId"] = searchParams.updateUserId;
    }
    if (searchParams.fromBinIds) {
        params["fromBinIds"] = searchParams.fromBinIds.join();
    }
    if (searchParams.toBinIds) {
        params["toBinIds"] = searchParams.toBinIds.join();
    }

    return axios.get("/auth/location-movement", { params });

}

function printLocationMovementInvoice(id) {
    return orginal_axios({
        url: axios.defaults.baseURL + "/auth/location-movement/reprint-location-movement-invoice/" + id,
        method: "GET",
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/pdf",
            "Content-Type": "application/json"
        }
    }).then(function (response) {
        return new Blob([response.data], { type: "application/pdf" });
    });

}

function getLocationMovementExcelTemplate() {
    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/location-movement/location-movement-excel-template",
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

function saveLocationMovementExcel(file) {
    return axios.post('/auth/location-movement/location-movement-excel',
        file,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    )
}

function exportAllLocationMovementExcel(searchParams) {
    return orginal_axios({
        url: axios.defaults.baseURL + "/auth/location-movement/print-location-movement-excel/",
        method: "GET",
        responseType: "arraybuffer", // important
        params: {
            fromWarehouseId: searchParams.fromWarehouseId,
            toWarehouseId: searchParams.toWarehouseId,
            fromBinId: searchParams.fromBinId,
            toBinId: searchParams.toBinId,
            fromDate: searchParams.fromDate,
            toDate: searchParams.toDate,
            issueNo: searchParams.issueNo,
            serialNo: searchParams.serialNo,
            updateUserId: searchParams.updateUserId,
            referenceNo: searchParams.referenceNo,
            fromBinIds: searchParams.fromBinIds.join(),
            toBinIds: searchParams.toBinIds.join(),
        },
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

